import { BasicResult } from "../basic-result";
import { ActionFilters } from "./action-filters";

export class ActionFiltersResult extends BasicResult{
     public Filters: ActionFilters = new ActionFilters();
        constructor(values: Object = {}) {
            super();
            Object.assign(this, values);
        }
}